/**
 * Verse-anchor lines — the V6.4 pericope commentary block-anchor contract.
 *
 * Wire format: each commentary paragraph opens with an anchor line naming the
 * verse range it expounds, joined to its prose by a single newline; blocks are
 * separated by blank lines:
 *
 *   Verses 14-16\n<paragraph prose>\n\nVerse 17\n<paragraph prose>
 *
 * The anchor is an ENTIRE line: ASCII hyphen range, no trailing punctuation,
 * no markdown. This module is the single source of truth for the shape —
 * services (normalizer/truncator), api (validator), web (renderer), and
 * study-pdf all import from here. Never mirror the regex.
 */
/** Matches a canonical anchor line in full: "Verse 7" or "Verses 14-16". */
export const VERSE_ANCHOR_RE = /^Verses? (\d{1,3})(?:-(\d{1,3}))?$/;
/**
 * Parse a single line as a verse anchor.
 * Lenient on singular/plural mismatch ("Verse 14-16"); null for reversed
 * ranges and anything that is not the entire line.
 */
export function parseVerseAnchor(line) {
    const match = VERSE_ANCHOR_RE.exec(line.trim());
    if (!match)
        return null;
    const start = Number(match[1]);
    const end = match[2] ? Number(match[2]) : start;
    if (end < start)
        return null;
    return { start, end };
}
/** Format an anchor in canonical wire form: "Verse 7" / "Verses 14-16". */
export function formatVerseAnchor(anchor) {
    return anchor.start === anchor.end
        ? `Verse ${anchor.start}`
        : `Verses ${anchor.start}-${anchor.end}`;
}
/**
 * Split one `\n\n`-delimited commentary block into its anchor line (if the
 * first line is one) and the prose beneath it.
 */
export function splitAnchorBlock(block) {
    const newlineAt = block.indexOf('\n');
    const firstLine = newlineAt === -1 ? block : block.slice(0, newlineAt);
    const anchor = parseVerseAnchor(firstLine);
    if (!anchor)
        return { anchor: null, anchorText: null, prose: block };
    const prose = newlineAt === -1 ? '' : block.slice(newlineAt + 1);
    return { anchor, anchorText: firstLine.trim(), prose };
}
//# sourceMappingURL=verse-anchors.js.map